export default {
    actionUndo: {
        message: "Si hizo clic por error, haga clic en el enlace a continuación para revertir.",
        undo: "Haga clic para deshacer"
    }
}